import { useCollection } from '@/features/events/contexts/CollectionContext/useCollection';
import type { DecoratedIntegration } from '@/pages/Schedule/hooks/useIntegrations';
import { Flex, Link } from '@/ui';
import { isValidEmail } from '@/utils/validation';
import { useCalendarAuth } from '../../hooks/useCalendarAuth';
import { BasicGoogleCalendarButton } from '../BasicGoogleCalendarButton';
import { Notification } from './Notification';

type Props = {
  integration: DecoratedIntegration;
};

export const IntegrationError = ({ integration }: Props) => {
  const { base } = useCollection();
  const { handleCalendarAuth } = useCalendarAuth({ base: base ?? undefined });

  return (
    <Flex flexDirection="column" gap="2" justify="space-between" p="4">
      <Notification status="info">
        Email{' '}
        <Link
          as="span"
          href="mailto:support@agendahero.com?subject=Issues connecting Google Calendar"
        >
          support@agendahero.com
        </Link>{' '}
        for help connecting accounts.
      </Notification>

      <Notification status="warning">
        Please allow requested permissions in order to add events to your
        calendar.
      </Notification>

      <Flex align="baseline" gap="4" justify="flex-end">
        <BasicGoogleCalendarButton
          message="Reconnect Google Calendar"
          onClick={() =>
            handleCalendarAuth({
              email: isValidEmail(integration.externalId)
                ? integration.externalId
                : undefined,
            })
          }
        />
      </Flex>
    </Flex>
  );
};
